<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
* {
  box-sizing: border-box;
}
body {
      background: #172B4D;
      padding-top: 60px;
      font-family: 'Avenir', 'Open Sans', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #fff;
  }

#app {
}

footer {
  margin-top: 200px;
}
</style>



// WEBPACK FOOTER //
// App.vue?65513fd2